import { FC, Suspense } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { ThrowNotFound } from 'src/components/not-found';
import {
  LayoutContainer,
  LayoutContent,
  LayoutSidebar,
} from 'src/components/sidebar';
import { PageSpinner } from 'src/components/spinner-container';
import { NotificationSettings } from 'src/pages/settings/notifications';
import { OrganisationManagement } from 'src/pages/settings/organisation';
import { useOrganisationService } from 'src/pages/settings/organisation/use-organisation-service';
import { Profile } from 'src/pages/settings/profile';
import { SettingsSidebar } from 'src/pages/settings/sidebar';

export const Settings: FC = () => {
  const organisationService = useOrganisationService();

  if (!organisationService.response) return <PageSpinner />;

  return (
    <LayoutContainer>
      <LayoutSidebar>
        <SettingsSidebar organisationService={organisationService} />
      </LayoutSidebar>

      <LayoutContent>
        <Suspense fallback={<PageSpinner />}>
          <Switch>
            <Route path="/settings/profile" exact>
              <Profile />
            </Route>

            <Route path="/settings/notifications">
              <NotificationSettings />
            </Route>

            <Route path="/settings/organisation/users">
              <OrganisationManagement />
            </Route>

            <Route>
              <ThrowNotFound />
            </Route>
          </Switch>
        </Suspense>
      </LayoutContent>
    </LayoutContainer>
  );
};

export const ProfileSettingsRedirect: FC = () => {
  const { pathname, search, state, hash } = useLocation();
  return (
    <Redirect
      to={{
        pathname: pathname.replace('/profile-settings', '/settings'),
        search,
        state,
        hash,
      }}
    />
  );
};
